import React, { useCallback, useEffect, useMemo } from 'react';
import RowModal from './RowModal'
import GenericConstants from 'constants/GenericConstants'
import { useHistory } from 'react-router-dom';
import FileRow from './FileRow'
import { useFileUpload } from '../../contexts/FileUploadContext'

const FileLoadingModal = () => {
  const history = useHistory();
  const { 
    filesArray, 
    isModalVisible, 
    hasTooBigError,
    fileStatus,
    hideModal
  } = useFileUpload();

  
  // Simple computed values
  const showModal = isModalVisible && filesArray.length > 0;
  const isLoading = fileStatus?.isLoading || false;
  const message = fileStatus?.message || '';
  
  // Build error message with file size warning if needed
  let errorMessage = fileStatus?.errorMessage || null;
  if (errorMessage && hasTooBigError) {
    errorMessage = `${errorMessage}. Files need to be under ${GenericConstants.CONTEST_MAX_CHARACTERS/1000},000 characters.`;
  }

  const handleStartCoding = useCallback(() => {
    const firstTranscript = filesArray.find(file => file.transcript_id);
    if (firstTranscript) {
      hideModal();
      history.push(`/transcripts/${firstTranscript.transcript_id}`);
    }
  }, [filesArray, history, hideModal]);

  const beforeUnloadFunction = useCallback((e) => {
    if (!isLoading) {
      return;
    }
    e.preventDefault();
    e.returnValue = 'Files have not finished uploading';
    return 'Files have not finished uploading';
  }, [isLoading]);

  useEffect(() => {
    window.addEventListener("beforeunload", beforeUnloadFunction);

    return () => {
      window.removeEventListener("beforeunload", beforeUnloadFunction);
    };
  }, [beforeUnloadFunction]);

  return (
    <div>
      <RowModal
        show={showModal}
        onHide={hideModal}
        buttonText='Start coding'
        buttonAction={handleStartCoding}
        buttonDisabled={!filesArray.some(file => file.transcript_id)}
        secondaryButtonText='Add more transcripts'
        secondaryButtonAction={hideModal}
        header={<h4 style={{marginTop:0}}>{message}</h4>}
        errorMessage={errorMessage}
      >
        {filesArray.map((file, index) => {
          const hasError = !!file.error;
          return <FileRow
            name={file.fileName}
            loaded={!!file.loaded}
            transcript_id={file?.transcript_id}
            error={hasError}
            errorMessage={hasError ? file.error.message : null}
            onHide={hideModal}
            file={file}
            key={file.id || index}
          />;
        })}
      </RowModal>
    </div>
  );
};

export default FileLoadingModal;